/**
 * @callback CreateLocalesCollection Get the full fact with the carcters length.
 * @param {Locale[]} localesData
 * @param {Function} translate
 * @returns {{ [key: string]: { id: string, label: string, value: string } }}
 */
/** @type {CreateLocalesCollection} */
export const createLocalesCollection = (localesData, translate) => localesData
  .reduce((acc, locale) => {
    acc[locale.id] = { ...locale, label: translate(`cortizol.locales.${locale?.id}`), value: locale.id };
    return acc;
  }, /** @type {{ [key: string]: { id: string, label: string, value: string } }} */ ({}));
